// hooks/useQueryParam.ts
import { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

/**
 * Hook para gerenciar um único query param na URL.
 * @param key Nome do parâmetro
 * @returns [value, setValue]
 */
export default function useQueryParam(
  key: string
): [string | null, (val: string | null) => void] {
  const { search, pathname } = useLocation();
  const history = useHistory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const params = new URLSearchParams(search);
  const value = params.get(key);

  const setValue = useCallback(
    (newVal: string | null) => {
      const next = new URLSearchParams(params.toString());
      if (newVal === null) next.delete(key);
      else next.set(key, newVal);
      history.replace({ pathname, search: next.toString() });
    },
    [history, key, pathname, params]
  );

  return [value, setValue];
}
